var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle, _path52, _circle2, _path53, _path54, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceCream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 352,
    viewBox: "0 0 300 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.32 212.92L152.89 348.49C152.423 349.833 151.157 350.733 149.735 350.733C148.313 350.733 147.047 349.833 146.58 348.49L89 183.77C92.4403 186.574 96.2366 188.911 100.29 190.72C104.216 192.383 107.657 195.015 110.29 198.37C119.85 211.08 116.37 228.23 129.29 229.08C144.45 230.08 141.2 192.08 148.13 191.14C155.06 190.2 156.52 202.14 161.45 203.06C165.27 203.78 169.13 202.67 172.02 190.73C174.91 178.79 181.91 185.37 185.2 201.85C187.18 212 194.33 216.36 200.32 212.92Z",
    fill: "#FCEAD2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.29 223.67L149.48 350.73L121.29 223.67Z",
    fill: "#FCEAD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.29 223.67L149.48 350.73",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.16 201.84L149.74 350.49L185.16 201.84Z",
    fill: "#FCEAD2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.16 201.84L149.74 350.49",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.13 216.95L149.74 350.49L140.13 216.95Z",
    fill: "#FCEAD2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.13 216.95L149.74 350.49",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.46 203.2L150.13 349.66L162.46 203.2Z",
    fill: "#FCEAD2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.46 203.2L150.13 349.66",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.42 207.41C157.056 207.772 171.701 207.18 186.26 205.64L142.42 207.41Z",
    fill: "#FCEAD2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.42 207.41C157.056 207.772 171.701 207.18 186.26 205.64",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.76 203.2C95.76 203.2 102.91 204.54 114.76 205.72L95.76 203.2Z",
    fill: "#FCEAD2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.76 203.2C95.76 203.2 102.91 204.54 114.76 205.72",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.19 225.61C156.463 226.38 176.763 225.202 196.81 222.09L136.19 225.61Z",
    fill: "#FCEAD2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M136.19 225.61C156.463 226.38 176.763 225.202 196.81 222.09",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.57 222.68C106.65 223.27 114.57 224.24 121.57 224.85L102.57 222.68Z",
    fill: "#FCEAD2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.57 222.68C106.65 223.27 114.57 224.24 121.57 224.85",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.45 242.32C126.86 244.26 157.12 246.2 190.16 241.96L109.45 242.32Z",
    fill: "#FCEAD2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.45 242.32C126.86 244.26 157.12 246.2 190.16 241.96",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 261.45C138.628 263.497 161.276 263.233 183.72 260.66L116.13 261.45Z",
    fill: "#FCEAD2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.13 261.45C138.628 263.497 161.276 263.233 183.72 260.66",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.34 279.09C140.577 280.533 158.899 280.56 177.14 279.17L122.34 279.09Z",
    fill: "#FCEAD2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M122.34 279.09C140.577 280.533 158.899 280.56 177.14 279.17",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M128.91 298C142.815 298.793 156.755 298.713 170.65 297.76L128.91 298Z",
    fill: "#FCEAD2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.91 298C142.815 298.793 156.755 298.713 170.65 297.76",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134 312.25C143.38 312.7 154.07 312.85 165.54 312.38L134 312.25Z",
    fill: "#FCEAD2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134 312.25C143.38 312.7 154.07 312.85 165.54 312.38",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M140.13 330.87C146 331 152.35 331 159 330.82L140.13 330.87Z",
    fill: "#FCEAD2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M140.13 330.87C146 331 152.35 331 159 330.82",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M208.64 196.58C209.74 188.9 216 178.74 217 176.37C218 174 220 168.5 220.504 167.08C221.009 165.66 231.019 144.343 231 132C231 92.77 194.971 61 150.536 61C117.375 61 89.4663 77.58 77.2085 102.88C73.5602 111.207 70.9999 128 70.9999 128C70.9999 128 70 132 71.2599 152.35C72.5199 172.7 84.6362 183.77 100.26 190.72C104.186 192.384 107.627 195.016 110.26 198.37C119.83 211.08 116.35 228.23 129.26 229.08C144.42 230.06 141.07 192.12 148.1 191.14C155.13 190.16 156.49 202.06 161.42 203.06C165.24 203.78 169.11 202.69 171.99 190.73C174.87 178.77 181.88 185.37 185.17 201.85C187.19 211.92 194.33 216.36 200.33 212.92C204.08 210.75 207.37 205.49 208.64 196.58Z",
    fill: "#5CC9FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3399 135.14C80.9999 139 79.4799 145.91 81.1799 155.93",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M122.78 215C123.96 220.2 125.69 223.2 129.11 223.19C130.421 223.332 131.67 222.602 132.19 221.39",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M207.62 126.95L221.61 145.01",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M216.66 127.96L224.54 138.13",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M206.43 136.09L214.61 146.64",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M219.43 127.96L206.83 144.22",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M212.74 125.92L207.62 132.53",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M223.32 133.6L215.27 143.98",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M108.336 117C108.336 117 114.826 99 132.994 117",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M188.843 117C188.843 117 182.364 99 164.196 117",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M113.392 97.24C113.392 97.24 126.952 98.3 132.95 94",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M148.59 132.83C152.814 132.83 152.825 126.83 148.59 126.83C144.354 126.83 144.365 132.83 148.59 132.83Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M210.45 258.54C203.85 258.54 201.61 253.32 201.62 249.4C201.655 247.193 202.103 245.012 202.94 242.97C204.743 238.735 206.96 234.688 209.56 230.89C209.767 230.609 210.096 230.443 210.445 230.443C210.794 230.443 211.123 230.609 211.33 230.89C214.161 234.687 216.481 238.839 218.23 243.24C218.23 243.24 223.93 258.54 210.45 258.54Z",
    fill: "#EF83FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M205.85 248.39C205.85 248.39 204.96 253.68 210.52 254.31",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M195.52 290.21C194.401 290.252 193.316 289.817 192.537 289.011C191.759 288.206 191.36 287.107 191.44 285.99C191.448 284.96 191.655 283.941 192.05 282.99C192.877 281.033 193.903 279.167 195.11 277.42C195.204 277.29 195.355 277.213 195.515 277.213C195.675 277.213 195.826 277.29 195.92 277.42C197.284 279.314 198.41 281.37 199.27 283.54C199.27 283.54 201.74 290.21 195.52 290.21Z",
    fill: "#5CC9FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8599 218.77C76.3099 218.77 74.7599 215.17 74.7699 212.47C74.7918 210.935 75.1039 209.419 75.6899 208C76.9323 205.08 78.4597 202.29 80.2499 199.67C80.3933 199.477 80.6196 199.363 80.8599 199.363C81.1003 199.363 81.3266 199.477 81.4699 199.67C83.4211 202.29 85.0213 205.155 86.2299 208.19C86.2299 208.19 90.1599 218.77 80.8599 218.77Z",
    fill: "#5CC9FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M77.69 211.77C77.5067 212.75 77.757 213.762 78.3763 214.545C78.9956 215.327 79.9233 215.803 80.92 215.85",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M177.377 22.0933C172.344 28.4044 166.18 33.7234 159.2 37.7783C158.144 38.3836 157.041 39.03 155.898 39.7487C146.656 45.518 142.726 51.9093 142.717 56.6906C142.737 58.9107 143.258 61.0975 144.243 63.0873C146.026 66.7693 152.586 70.41 159.704 70.6072C162.376 70.6953 165.038 70.2405 167.529 69.2704C168.451 68.8815 169.425 68.6296 170.419 68.5228C171.935 68.3524 173.605 68.6573 174.11 70.6172C174.338 71.8378 174.285 73.0944 173.953 74.2912C171.846 83.7742 179.624 91.3263 190.023 88.0012C190.441 87.8714 190.871 87.7901 191.307 87.7587C192.031 87.668 192.765 87.7754 193.432 88.0694L193.506 88.1336C195.215 88.9916 196.878 91.3431 194.968 97.541C194.693 98.4824 194.283 99.5535 193.809 100.711C190.619 108.465 188.632 114.03 188.81 118.596C188.949 122.255 190.448 125.244 193.786 128.14C197.123 131.036 201.884 129.682 206.88 127.283C213.038 124.264 219.533 119.567 223.959 119.115C230.567 118.432 226.413 129.879 237.011 129.262C239.978 128.751 242.907 128.037 245.777 127.126L245.974 127.049C246.134 127 246.301 126.944 246.479 126.874C256.914 123.405 266.219 117.185 273.415 108.87C296.322 82.4748 292.723 41.8761 265.406 18.1692C245.018 0.476681 218.18 -3.25733 195.871 7.22581C188.766 10.8821 182.475 15.9396 177.377 22.0933Z",
    fill: "#EF83FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M263.839 105.974C262.467 107.168 261.027 108.282 259.528 109.311",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M275.411 89.3232C273.556 94.6126 270.538 99.4185 266.579 103.387",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M154.19 49.1659C153.287 49.8928 152.358 50.6785 151.531 51.4823C148.682 54.2478 148.92 58.4054 152.768 60.4002",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213.878,
    cy: 42.0682,
    r: 10.0224,
    transform: "rotate(40.9523 213.878 42.0682)",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M212.103 44.1145C214.7 46.3684 218.211 42.3371 215.607 40.0774C213.003 37.8176 209.506 41.8605 212.103 44.1145Z",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.982,
    cy: 70.7977,
    r: 10.0224,
    transform: "rotate(40.9523 246.982 70.7977)",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M245.207 72.8439C247.804 75.0978 251.314 71.0666 248.71 68.8069C246.106 66.5471 242.61 70.59 245.207 72.8439Z",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M217.458 20.8169C217.458 20.8169 228.329 28.8827 234.88 27.3139",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M265.795 62.7656C265.795 62.7656 256.279 53.1389 256.91 46.4316",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M215.868 65.3693C217.24 65.2494 218.622 65.3282 219.971 65.6031C221.536 65.8524 223.31 67.1919 222.841 68.9555C222.738 69.4029 222.522 69.8163 222.213 70.1557C220.177 72.3522 216.445 72.9004 212.601 71.6758",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream);
export default __webpack_public_path__ + "static/media/ice-cream.36184a511a26da4d634cd431540c7eb1.svg";
export { ForwardRef as ReactComponent };